export default __webpack_public_path__ + "static/media/homePage.c5792018.png";